import Vue from "vue";
// import firebase from 'firebase';

const state = [
	{
		id: 			"HhoSAanfneFrKeASrw8", 
		organisation: 	"RoHvoiRymMd4N2B",
		users: 			["x3tTLMFYvIMGAG3mHPbeWGGVJBM2"],
		assessment: 	"s416ENLe6cIZilJrnQf0",
		lead: 			false, 
		current_part: 	0,
		current_section: 0,
		subject_collaborations: {
			IT: "colleague1",
			Klinikwesen: null,
			Betriebsleitung: "colleague3"
		},
		responses: [
		{
			"id": "Yx2dodTwL0uy",
			"created": {
				"seconds": 1604504200,
				"nanoseconds": 319000000
			},
			"user": "",
			"data": {
				"q95mQ29kFb3b": {
					"Die-elektronische-Gesundheitskarte-(eGK)-wird-zum-Online-Abgleich-der-Versichertenstammdaten-genutzt.": "Gar-nicht",
					"Digitale-Datenübermittlung-von-Patientendaten-durch-externe-KollegInnen-findet-statt.": "Minimal"
				}
			},
			"part": 0,
			"section": 0,
			"completion_rate": {
				"total": 6,
				"Struktur": 25,
				"nEvXC6LiodUp": 40,
				"O1buT5eqf9G7": 0,
				"Prozess": 0,
				"z2Clmkrc0CqM": 0,
				"Ergebnis": 0,
				"GHv7JhvYAVnY": 0,
				"HfQeYi5oDo1V": 0,
				"hdRivB3HiKS3": 0
			},
			"survey": "j3Y82NDizH2h",
			"status": "in_progress"
		}],
		"scores": {
			"total": 25,
			"Struktur": 25,
			"nEvXC6LiodUp": 25,
			"O1buT5eqf9G7": 0,
			"Prozess": 0,
			"z2Clmkrc0CqM": 0,
			"Ergebnis": 0,
			"GHv7JhvYAVnY": 0,
			"HfQeYi5oDo1V": 0,
			"hdRivB3HiKS3": 0
		}
			
	},
]


const actions = {
	updateResponse({state}, 
		{response_id, data, completion_rate} ){
		var response = state[0].responses.find( a => a.id == response_id );
		var index = state[0].responses.indexOf( response )
		response.data = data;
		response.completion_rate = completion_rate;
		Vue.set( state[0].responses, index, response )
	},
	newResponse({state, commit}, response ){
		var responses = state[0].responses;
		responses.push( response );
		commit("UPDATE_RESPONSES",responses )
	},
	removeSubjectUser({state}, subject ){
		state[0].subject_collaborations[subject] = null;
	},
	saveSubjectUser({state}, {subject, user} ){
		Vue.set(state[0].subject_collaborations, subject, user);
	},
	setScores( {state}, scores ){
		Vue.set(state[0], "scores", scores )
	}
} 

const mutations = {
	UPDATE_RESPONSES(state, responses ){
		Vue.set(state[0], "responses", responses )
	},
	SET_LEAD(state){
		Vue.set(state[0], "lead", "x3tTLMFYvIMGAG3mHPbeWGGVJBM2")
		Vue.set(state[0].responses[0], "user", "x3tTLMFYvIMGAG3mHPbeWGGVJBM2")
	},
	SET_SECTION(state, {part, section}){
		Vue.set(state[0], "current_part", part )
		Vue.set(state[0], "current_section", section )
	}
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
